import { getVehicleServiceHistory_ByRegNo } from '../../../Core/Service/loanVehicleUsage-service';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from '@material-ui/core';

import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import formatters from '../../../Core/Grid/inputFormatter';

const StyledTableCell = withStyles(() => ({}))(TableCell);

const StyledHeaderTableCell = withStyles(() => ({
    head: {
        border: '1px solid rgba(0,0,0,0.05)',
        fontWeight: 600
    }
}))(TableCell);

const StyledHeaderTableRow = withStyles(() => ({}))(TableRow);

const useStyles = makeStyles(() => ({
    root: { width: '100%' },
    table: {
        border: '1px solid rgba(0,0,0,0.05)',
        '& .MuiTableCell-root': { padding: '4px 6px' }
    },
    tbody: { padding: '0px !important' },
    loaderWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 150
    },
    tableContainer: {
        width: '100%',
        minHeight: 300,
        maxHeight: 500, // ✅ limit max height
        overflowY: 'auto', // ✅ vertical scroll
        overflowX: 'auto' // ✅ horizontal scroll
    }
}));

const VehicleServiceHistory = ({ Vehicle }) => {
    const classes = useStyles();
    const [state, setState] = useState({ jobs: [] });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                let res = await getVehicleServiceHistory_ByRegNo(Vehicle);
                if (res && res.success) {
                    setState({ jobs: res.data || [] });
                }
            } catch (error) {
                console.error('Error fetching vehicle service history:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [Vehicle]);

    return (
        <TableContainer className={classes.tableContainer}>
            {loading ? (
                <div className={classes.loaderWrapper}>
                    <CircularProgress size={28} />
                </div>
            ) : (
                <Table className={classes.table} stickyHeader size="small">
                    <TableHead>
                        <StyledHeaderTableRow>
                            <StyledHeaderTableCell>WIP No</StyledHeaderTableCell>
                            <StyledHeaderTableCell>Reg No</StyledHeaderTableCell>
                            <StyledHeaderTableCell>Branch</StyledHeaderTableCell>
                            <StyledHeaderTableCell>Account</StyledHeaderTableCell>
                            <StyledHeaderTableCell>Invoice</StyledHeaderTableCell>
                            <StyledHeaderTableCell>Details</StyledHeaderTableCell>
                            <StyledHeaderTableCell>Mileage</StyledHeaderTableCell>
                            <StyledHeaderTableCell>Value</StyledHeaderTableCell>
                            <StyledHeaderTableCell>Date</StyledHeaderTableCell>
                        </StyledHeaderTableRow>
                    </TableHead>
                    <TableBody className={classes.tbody}>
                        {state.jobs.length > 0 ? (
                            state.jobs.map((row, index) => (
                                <TableRow hover key={index}>
                                    <StyledTableCell>{row.wipNo || '-'}</StyledTableCell>
                                    <StyledTableCell>{row.vehicle || '-'}</StyledTableCell>
                                    <StyledTableCell>{row.branchlocation || '-'}</StyledTableCell>
                                    <StyledTableCell>{row.account || '-'}</StyledTableCell>
                                    <StyledTableCell>{row.invoice || '-'}</StyledTableCell>
                                    <StyledTableCell>{row.details || '-'}</StyledTableCell>
                                    <StyledTableCell>{formatters.ThousandSeparatorWithoutZero(row.mileage) ?? '-'}</StyledTableCell>
                                    <StyledTableCell>{formatters.CurrencyThousandSeparator(row.value) ?? '-'}</StyledTableCell>
                                    <StyledTableCell>{row.date ? moment(row.date).format('DD/MM/YYYY') : '-'}</StyledTableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={9} align="center">
                                    No records found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            )}
        </TableContainer>
    );
};

export default VehicleServiceHistory;
